import React from "react";
import "./Footer.scss";

export default function Footer() {
  const scrollTo = id => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({behavior: "smooth"});
  };

  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__left">
          <span className="footer__name">Srimonchaari</span>
          <p className="footer__copy">
            © {new Date().getFullYear()} · Full-Stack Engineer, Applied AI
          </p>
        </div>
        <nav className="footer__links" aria-label="Footer navigation">
          <button
            onClick={() => scrollTo("experience")}
            className="footer__link"
          >
            Experience
          </button>
          <button
            onClick={() => scrollTo("engineering")}
            className="footer__link"
          >
            Work
          </button>
          <button onClick={() => scrollTo("skills")} className="footer__link">
            Capabilities
          </button>
          <a href="mailto:srimonchaari@gmail.com" className="footer__link">
            Email
          </a>
          <a
            href="https://linkedin.com/in/Srimon"
            target="_blank"
            rel="noreferrer"
            className="footer__link"
          >
            LinkedIn
          </a>
          <a
            href="https://github.com/Srimonchaari"
            target="_blank"
            rel="noreferrer"
            className="footer__link"
          >
            GitHub
          </a>
        </nav>
      </div>
    </footer>
  );
}
